import React, {useState, useMemo} from 'react';
import {connect} from 'react-redux';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import RowLayout from '../../../../components/Layouts/RowLayout';
import SMCButton from '../../../../components/Simple/SMCButton';
import SetGatewayModal from '../../../PopupPages/SetGatewayModal';
import {useBoolean} from '../../../../utils/hooks';
import Sepperator from '../../../../components/Simple/Sepperator';
import SMCLink from '../../../../components/Simple/SMCLink';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {SMCPaths} from '../../../../conf/Routes';
import {useTranslation} from 'react-i18next';
import {push} from 'connected-react-router';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import {disabledIcon, connectedIcon, disconnectedIcon} from '../../../../assets/images/gateway';
import standbyIcon from '../../../../assets/images/standby.png';
import inactiveIcon from '../../../../assets/images/inactive.png';

const pageSchema = GatewayGetSchema.pages.haStatus;
const pageId = pageSchema.pageId;

function GatewayHaStatus({
    gatewayObject,
    setGatewayData,
    navigateTo
}) {
    const { t } = useTranslation();
    const pageData = gatewayObject[pageId];

    const state        = pageData[pageSchema.state];
    const details      = pageData[pageSchema.details];
    const member1      = pageData[pageSchema.member1];
    const member2      = pageData[pageSchema.member2];
    const memberSchema = pageSchema.memberSchema;

    const hasMember1 = Boolean(member1 && member1[memberSchema.state]);
    const hasMember2 = Boolean(member2 && member2[memberSchema.state]);

    const [member1NameToAdd, setMember1NameToAdd] = useState('');
    const [member2NameToAdd, setMember2NameToAdd] = useState('');

    const [isSetGatewayModalOpen, openSetGatewayModal, closeSetGatewayModal] = useBoolean(false);
    const [editedGatewayIndex, setEditedGatewayIndex] = useState(0);

    const emptyHaMemberObject = useMemo(() => ({
        [memberSchema.name]: null,
        [memberSchema.state]: null,
        [memberSchema.macAddress]: null,
        [memberSchema.lastConnectedIPAddress]: null,
        [memberSchema.reportedFirmware]: null,
        [memberSchema.connectionStatus]: null
    }), [memberSchema]);

    return (
        <EditorLayout>
            <SMCTextInput
                label="State"
                value={state}
                readOnly
            />
            <SMCTextInput
                label="Details"
                value={details}
                readOnly
            />
            <Sepperator />
            {
                hasMember1 && (
                    <>
                    <RowLayout>
                        <SMCTextInput
                            value={member1[memberSchema.name]}
                            label="Member 1"
                            readOnly
                            width={120}
                        />
                        <SMCLink
                            ignoreDisabledContext
                            underline
                            onClick={() => navigateTo(`${SMCPaths.gateways}?id=${member1[memberSchema.name]}`)}
                        >
                                <SMCIcon icon="rightArrow" /> {t('SMC_GEN_GO')}
                        </SMCLink>
                        <SMCButton onClick={() => setGatewayData([pageId, pageSchema.member1], emptyHaMemberObject)}>Remove</SMCButton>
                    </RowLayout>
                    <RowLayout>
                        <SMCLabel useContextWidth>State</SMCLabel>
                        {
                            (() => {
                                switch (member1[memberSchema.state]) {
                                    case memberSchema.stateValues.unknown:
                                        return <img src={disabledIcon} alt="" />;
                                    case memberSchema.stateValues.standby:
                                        return <img src={standbyIcon} alt="" />;
                                    case memberSchema.stateValues.active:
                                        return <img src={connectedIcon} alt="" />;
                                    case memberSchema.stateValues.inactive:
                                        return <img src={inactiveIcon} alt="" />;
                                    case memberSchema.stateValues.down:
                                        return <img src={disconnectedIcon} alt="" />;
                                    default:
                                        return null;
                                }
                            })()
                        }
                        <SMCTextInput style={{ paddingLeft: '4px' }} value={member1[memberSchema.detailedState]} readOnly />
                    </RowLayout>
                    <SMCTextInput
                        value={member1[memberSchema.macAddress]}
                        label="MAC address"
                        readOnly
                    />
                    <SMCTextInput
                        value={member1[memberSchema.lastConnectedIPAddress]}
                        label="Last Connected IP Address"
                        readOnly
                    />
                    <SMCTextInput
                        value={member1[memberSchema.reportedFirmware]}
                        label="Reported Firmware"
                        readOnly
                    />
                    <RowLayout>
                        <SMCLabel useContextWidth>Connection Status</SMCLabel>
                        {
                            (() => {
                                switch (member1[memberSchema.connectionStatus]) {
                                    case memberSchema.connectionStatusValues.connected:
                                        return <img src={connectedIcon} alt="" />;
                                    case memberSchema.connectionStatusValues.notConnected:
                                        return <img src={disconnectedIcon} alt="" />;
                                    case memberSchema.connectionStatusValues.disabled:
                                        return <img src={disabledIcon} alt="" />;
                                    default:
                                        return null;
                                }
                            })()
                        }
                    </RowLayout>
                    </>
                )
            }
            {
                !hasMember1 && (
                    <RowLayout>
                        <SMCTextInput
                            value={member1NameToAdd}
                            onChange={e => setMember1NameToAdd(e.target.value)}
                            label="Member 1"
                        />
                        <SMCButton onClick={() => {
                            openSetGatewayModal();
                            setEditedGatewayIndex(0);
                        }}>
                            Add
                        </SMCButton>
                    </RowLayout>
                )
            }
            <Sepperator />
            {
                hasMember2 && (
                    <>
                    <RowLayout>
                        <SMCTextInput
                            value={member2[memberSchema.name]}
                            label="Member 2"
                            readOnly
                            width={120}
                        />
                        <SMCLink
                            ignoreDisabledContext
                            underline
                            onClick={() => navigateTo(`${SMCPaths.gateways}?id=${member2[memberSchema.name]}`)}
                        >
                            <SMCIcon icon="rightArrow" /> {t('SMC_GEN_GO')}
                        </SMCLink>
                        <SMCButton onClick={() => setGatewayData([pageId, pageSchema.member2], emptyHaMemberObject)}>Remove</SMCButton>
                    </RowLayout>
                    <RowLayout>
                        <SMCLabel useContextWidth>State</SMCLabel>
                        {
                            (() => {
                                switch (member2[memberSchema.state]) {
                                    case memberSchema.stateValues.unknown:
                                        return <img src={disabledIcon} alt="" />;
                                    case memberSchema.stateValues.standby:
                                        return <img src={standbyIcon} alt="" />;
                                    case memberSchema.stateValues.active:
                                        return <img src={connectedIcon} alt="" />;
                                    case memberSchema.stateValues.inactive:
                                        return <img src={inactiveIcon} alt="" />;
                                    case memberSchema.stateValues.down:
                                        return <img src={disconnectedIcon} alt="" />;
                                    default:
                                        return null;
                                }
                            })()
                        }
                        <SMCTextInput style={{ paddingLeft: '4px' }} value={member2[memberSchema.detailedState]} readOnly />
                    </RowLayout>
                    <SMCTextInput
                        value={member2[memberSchema.macAddress]}
                        label="MAC address"
                        readOnly
                    />
                    <SMCTextInput
                        value={member2[memberSchema.lastConnectedIPAddress]}
                        label="Last Connected IP Address"
                        readOnly
                    />
                    <SMCTextInput
                        value={member2[memberSchema.reportedFirmware]}
                        label="Reported Firmware"
                        readOnly
                    />
                    <RowLayout>
                        <SMCLabel useContextWidth>Connection Status</SMCLabel>
                        {
                            (() => {
                                switch (member2[memberSchema.connectionStatus]) {
                                    case memberSchema.connectionStatusValues.connected:
                                        return <img src={connectedIcon} alt="" />;
                                    case memberSchema.connectionStatusValues.notConnected:
                                        return <img src={disconnectedIcon} alt="" />;
                                    case memberSchema.connectionStatusValues.disabled:
                                        return <img src={disabledIcon} alt="" />;
                                    default:
                                        return null;
                                }
                            })()
                        }
                    </RowLayout>
                    </>
                )
            }
            {
                !hasMember2 && (
                    <RowLayout>
                        <SMCTextInput
                            value={member2NameToAdd}
                            onChange={e => setMember2NameToAdd(e.target.value)}
                            label="Member 2"
                        />
                        <SMCButton onClick={() => {
                            openSetGatewayModal();
                            setEditedGatewayIndex(1);
                        }}>
                            Add
                        </SMCButton>
                    </RowLayout>
                )
            }
            <SetGatewayModal
                isOpen={isSetGatewayModalOpen}
                onRequestClose={closeSetGatewayModal}
                selectMultiple={false}
                onSuccess={gwList => {
                    if (editedGatewayIndex === 0) {
                        setMember1NameToAdd(gwList[0]);
                        setGatewayData([pageId, pageSchema.member1, memberSchema.name], gwList[0]);
                    }
                    else if (editedGatewayIndex === 1) {
                        setMember2NameToAdd(gwList[0]);
                        setGatewayData([pageId, pageSchema.member2, memberSchema.name], gwList[0]);
                    }
                    closeSetGatewayModal();
                }}
            />

        </EditorLayout>
    )
}


const mapStateToProps = null;

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(GatewayHaStatus);